import { LotMailNotificationType } from './enums'

export type AccountingMailConfigData = {
	accountingMailData: AccountingMailData[]
	readOnly: boolean
	isAccountingMailDispatchingDisabled: boolean
	mailingList: string[]
	receiverList: string[]
	actualTargetComparisonFilled: boolean
	holidayDays: string[]
}
export function DefaultAccountingMailConfigData(): AccountingMailConfigData {
	return {
		accountingMailData: [
			DefaultAccountingMailData(LotMailNotificationType.FIRST_MAIL),
			DefaultAccountingMailData(LotMailNotificationType.SECOND_MAIL),
			DefaultAccountingMailData(LotMailNotificationType.THIRD_MAIL),
			DefaultAccountingMailData(LotMailNotificationType.FOURTH_MAIL),
			DefaultAccountingMailData(LotMailNotificationType.FIFTH_MAIL)
		],
		readOnly: true,
		isAccountingMailDispatchingDisabled: true,
		mailingList: [''],
		actualTargetComparisonFilled: false,
		receiverList: [
			'Case Owner: moritz.obexer@mineral-minds.de',
			'Optimierer: showcase-ag@mineral-minds.de',
			'Anbieter: bob.baumeister@mineral-minds.de'
		],
		holidayDays: ['2025-11-17', '2025-11-20']
	}
}

export type AccountingMailData = {
	dispatchDateMail: string | null
	mailType: LotMailNotificationType
	subject: string
	state: string
	htmlContent: string
	mailingList: string[]
}

function DefaultAccountingMailData(mailType: LotMailNotificationType): AccountingMailData {
	return {
		dispatchDateMail: null,
		mailType,
		subject: 'Mail 1: Aufforderung Mengen und preise zurückzumelden',
		state: 'Versendet',
		htmlContent: 'htmlContent',
		mailingList: []
	}
}
